import {post} from '../utils'

export default host =>
  async (material) =>
    await post(`${host}/files/completeUpload`, JSON.stringify(material), null)
      .then(response => response.json())